{
  "Editor": {
    "CameraTrack": {
      "Title": "Kamera",
      "Hint": "Ein Block je Szene: wen das Video dort zeigt. Klick ändert die Szene, Doppelklick beginnt eine neue, die Kante zwischen zwei Blöcken verschiebt den Schnitt. Tasten 1 bis 9 wählen eine Person, 0 alle.",
      "Everyone": "Alle",
      "Automatic": "Automatisch",
      "Edited": "Von dir geändert",
      "CardLabel": "Kamera dieser Szene",
      "Show": "Anzeigen",
      "Key": "Taste",
      "SplitHere": "Hier teilen",
      "BackToAuto": "Zurück zu automatisch",
      "Close": "Schließen"
    },
    "ClipLayout": {
      "Screen": "Bildschirm",
      "ScreenShort": "Bild",
      "ScreenOf": "Bildschirm von {{name}}",
      "ScreenFromTo": "{{screen}}, {{from}} bis {{to}}",
      "ScreenFrom": "{{screen}}, ab {{from}}",
      "ScreenAnd": "{{screen}} und {{name}}",
      "BrandKit": {
        "Title": "Video Brand Kit",
        "None": "Keins",
        "DefaultMark": "(Standard)",
        "Hint": "Rahmen, Hintergrund und Logo des Kits gelten für diesen Clip."
      }
    },
    "VideoLayout": {
      "Label": "Videolayout",
      "Auto": "Auto",
      "Grid": "Raster",
      "AutoHint": "Zeigt automatisch die sprechende Person und schneidet auf jeden Redebeitrag ab zwei Sekunden, zwischendurch alle Teilnehmenden. Die ersten und letzten 15 Sekunden zeigen alle.",
      "GridHint": "Zeigt alle Teilnehmenden durchgehend im Raster.",
      "AutoPending": "Die Sprechererkennung wird noch vorbereitet. Bis dahin zeigt das Video das Raster.",
      "Tab": "Layout",
      "TabHint": "Wie das Video zusammengesetzt wird: Szenenstil, Übergänge und Regie",
      "Style": {
        "Title": "Szenenstil",
        "solo": "Nur Sprecher",
        "soloHint": "Die sprechende Person füllt das Bild.",
        "pip": "Bild im Bild",
        "pipHint": "Die sprechende Person füllt das Bild, die vorherige erscheint in einem kleinen Fenster."
      },
      "Position": {
        "Title": "Position",
        "tl": "Oben links",
        "tr": "Oben rechts",
        "bl": "Unten links",
        "br": "Unten rechts"
      },
      "Transition": {
        "Title": "Übergang",
        "cut": "Schnitt",
        "cutHint": "Szenen wechseln mit einem harten Schnitt.",
        "fade": "Blende",
        "fadeHint": "Szenen gehen weich ineinander über."
      },
      "Director": {
        "Title": "Regie",
        "calm": "Ruhig",
        "calmHint": "Zeigt seltener alle Teilnehmenden und hält diese Ansicht länger.",
        "balanced": "Ausgewogen",
        "balancedHint": "Zeigt alle Teilnehmenden in natürlichem Tempo.",
        "lively": "Lebhaft",
        "livelyHint": "Zeigt alle Teilnehmenden öfter, in kurzen Einblendungen."
      },
      "OnlyInAuto": "Der Szenenstil gilt im Auto-Modus. Im Raster sind alle Teilnehmenden durchgehend zu sehen.",
      "OnlyInGrid": "Gilt im Raster-Modus.",
      "Look": {
        "Title": "Look",
        "Background": "Hintergrund",
        "Gradient": "Verlauf",
        "Angle": "Winkel",
        "Border": "Kachelrahmen",
        "BorderWidth": "Breite",
        "Radius": "Eckenradius",
        "Gap": "Kachelabstand",
        "GapHint": "0 zeigt die Kacheln Kante an Kante.",
        "Labels": "Namensschilder",
        "LabelFont": "Schrift",
        "LabelColor": "Farbe",
        "Logo": "Logo",
        "LogoNone": "Keins",
        "LogoHint": "Verwendet das Logo des Brand Kits.",
        "LogoMissing": "Lade ein Logo unter Einstellungen, Video Brand Kit hoch.",
        "Stage": "Bühne",
        "StagePadding": "Rand",
        "Band": "Logo-Band",
        "BandNone": "Keins",
        "BandTop": "Oben",
        "BandBottom": "Unten",
        "BandHeight": "Bandhöhe",
        "BandColor": "Bandfarbe",
        "BandUseBackground": "Hintergrundfarbe verwenden",
        "BandText": "Bandtext",
        "BandTextColor": "Textfarbe",
        "LogoHeight": "Logogröße",
        "LogoDragHint": "Ziehe das Logo in der Vorschau an seinen Platz.",
        "LogoReset": "Zurück in die Ecke",
        "LogoFromKit": "Verwendet das Logo dieses Video Brand Kits.",
        "BackgroundImage": "Hintergrundbild",
        "BackgroundImageUse": "Hintergrundbild verwenden",
        "BackgroundImageMissing": "Lade ein Hintergrundbild zum Video Brand Kit hoch."
      },
      "BrandKit": {
        "Title": "Video Brand Kit",
        "Custom": "Eigener Look",
        "Modified": "geändert",
        "SaveAs": "Als Video Brand Kit speichern",
        "Name": "Name",
        "NamePlaceholder": "z. B. New Heights",
        "Save": "Speichern",
        "Saving": "Speichern...",
        "Cancel": "Abbrechen",
        "Saved": "Video Brand Kit gespeichert.",
        "Logo": "Logo",
        "Background": "Hintergrundbild",
        "Upload": "Hochladen",
        "Remove": "Entfernen",
        "Default": "Standard-Kit für neue Clips",
        "DefaultMark": "(Standard)",
        "TooLarge": "Die Datei ist zu groß.",
        "Errors": {
          "forbidden": "Nur Company Admins können Video Brand Kits speichern.",
          "duplicate": "Ein Video Brand Kit mit diesem Namen existiert bereits.",
          "invalid": "Dieses Kit konnte nicht gespeichert werden. Bitte Name und Look prüfen.",
          "limit": "Das Limit von 50 Video Brand Kits ist erreicht. Bitte zuerst eins in den Einstellungen löschen.",
          "unknown": "Das hat nicht geklappt. Bitte erneut versuchen."
        }
      }
    },
    "SpeakerRename": {
      "Trigger": "Sprecher bearbeiten",
      "Tooltip": "Sprechernamen in diesem Transkript umbenennen",
      "Title": "Sprecher umbenennen",
      "Hint": "Hör in den ersten Satz jedes Sprechers rein, um ihn zu erkennen, und trage anschließend den echten Namen ein.",
      "PlaySample": "Hörprobe abspielen",
      "StopSample": "Hörprobe stoppen",
      "NewName": "Neuer Name",
      "Cancel": "Abbrechen",
      "Save": "Speichern",
      "Saved": "Sprechernamen aktualisiert.",
      "SaveFailed": "Sprechernamen konnten nicht gespeichert werden. Bitte erneut versuchen.",
      "NoSpeakers": "Keine Sprecher in diesem Transkript erkannt."
    },
    "CaptionStyle": {
      "Title": "Untertitel-Stil",
      "Close": "Panel schließen",
      "StepChoose": "1. Stil wählen",
      "StepCustomize": "2. Anpassen",
      "Customized": "(angepasst)",
      "OwnStyle": "Eigener Stil",
      "YourCompany": "Ihr Unternehmen",
      "Templates": "Vorlagen",
      "Default": "Standard",
      "DefaultForLong": "Standard für Langform-Videos",
      "DefaultForClip": "Standard für Promo Clips",
      "DefaultForBoth": "Standard für Langform-Videos und Promo Clips",
      "SampleText": "Neu",
      "SampleWord": "gedacht",
      "Font": "Schrift",
      "Size": "Größe",
      "Sizes": {
        "Small": "Klein",
        "Medium": "Mittel",
        "Large": "Groß"
      },
      "TextColor": "Textfarbe",
      "ActiveWord": "Aktives Wort",
      "Colors": {
        "White": "Weiß",
        "Yellow": "Gelb",
        "Black": "Schwarz",
        "LightBlue": "Hellblau",
        "Blue": "Blau",
        "Gold": "Gold",
        "Red": "Rot",
        "Green": "Grün",
        "Custom": "Eigene Farbe",
        "None": "Keine Hervorhebung"
      },
      "Position": "Position",
      "Positions": {
        "Top": "Oben",
        "Middle": "Mitte",
        "Bottom": "Unten"
      },
      "PositionHint": "Sie können die Untertitel auch im Player ziehen.",
      "Advanced": "Erweiterte Einstellungen",
      "Lines": "Einzelne Zeilen",
      "LinesHint": "Klicken Sie im Player auf eine Untertitelzeile, um nur diese Zeile anzupassen.",
      "LinesCount": "{{count}} Zeilen haben einen eigenen Stil.",
      "TextGroup": "Text",
      "ExactSize": "Genaue Größe",
      "Smaller": "Kleiner",
      "Larger": "Größer",
      "Weight": "Stärke",
      "FontStyle": "Stil",
      "Bold": "Fett",
      "Italic": "Kursiv",
      "Normal": "Normal",
      "Weights": {
        "Light": "Leicht",
        "Regular": "Normal",
        "Medium": "Mittel",
        "SemiBold": "Halbfett",
        "Bold": "Fett",
        "ExtraBold": "Extrafett",
        "Black": "Ultrafett"
      },
      "Capitalization": "Großschreibung",
      "Transforms": {
        "None": "Wie geschrieben",
        "Uppercase": "Großbuchstaben",
        "Lowercase": "Kleinbuchstaben",
        "Capitalize": "Wortanfänge groß"
      },
      "LetterSpacing": "Zeichenabstand",
      "LineHeight": "Zeilenhöhe",
      "Outline": "Kontur",
      "Color": "Farbe",
      "Width": "Breite",
      "Shadow": "Schatten",
      "Blur": "Unschärfe",
      "OffsetX": "Versatz X",
      "OffsetY": "Versatz Y",
      "Box": "Hintergrundbox",
      "Padding": "Innenabstand",
      "Radius": "Eckenradius",
      "WordHighlight": "Aktives Wort hervorheben",
      "HighlightSize": "Größe aktives Wort",
      "WordBackground": "Box um aktives Wort",
      "WordOutline": "Kontur des aktiven Worts",
      "Alignment": "Ausrichtung",
      "Aligns": {
        "Left": "Links",
        "Center": "Mitte",
        "Right": "Rechts"
      },
      "SaveAsCompany": "Als Unternehmens-Stil speichern",
      "Reset": "Zurücksetzen",
      "ResetTitle": "Zurück zum gewählten Stil",
      "Name": "Name",
      "NamePlaceholder": "z. B. Hausstil",
      "UseAsDefaultFor": "Als Standard verwenden für",
      "NewLong": "Neue Langform-Videos",
      "NewClip": "Neue Promo Clips",
      "SaveHint": "Alle im Unternehmen sehen diesen Stil. Bestehende Videos ändern sich nicht.",
      "Save": "Speichern",
      "Saving": "Wird gespeichert…",
      "Cancel": "Abbrechen",
      "MoreActions": "Weitere Aktionen für {{name}}",
      "Rename": "Umbenennen",
      "Delete": "Löschen",
      "ConfirmDelete": "{{name}} löschen? Videos, die ihn nutzen, behalten ihr Aussehen.",
      "UseForLong": "Standard für neue Langform-Videos",
      "UseForClip": "Standard für neue Promo Clips",
      "Overwrite": "Mit aktuellen Einstellungen ersetzen",
      "Errors": {
        "nameRequired": "Bitte einen Namen eingeben.",
        "duplicate": "Ein Stil mit diesem Namen existiert bereits.",
        "forbidden": "Nur Company Admins können Unternehmens-Stile ändern.",
        "invalid": "Dieser Stil konnte nicht gespeichert werden. Bitte die Einstellungen prüfen.",
        "unknown": "Das hat nicht geklappt. Bitte erneut versuchen.",
        "conflict": "Gleichzeitig wurde ein anderer Standard gesetzt. Bitte erneut versuchen."
      },
      "Line": {
        "Badge": "Zeile {{number}}",
        "EditingThisLine": "Änderungen hier gelten nur für diese Zeile",
        "ApplyToAll": "Auf alle Zeilen anwenden",
        "ApplyToAllTitle": "Die Einstellungen dieser Zeile für alle Zeilen übernehmen",
        "ResetLine": "Zeile zurücksetzen",
        "Done": "Fertig",
        "Own": "eigen",
        "Inherited": "global",
        "ResetField": "Zurück zum globalen Stil",
        "Fields": {
          "textColor": "Textfarbe",
          "activeWordColor": "Farbe aktives Wort",
          "fontSize": "Schriftgröße",
          "fontFamily": "Schrift",
          "fontWeight": "Stärke",
          "fontStyle": "Stil",
          "backgroundBoxColor": "Boxfarbe",
          "outlineColor": "Konturfarbe",
          "outlineWidth": "Konturbreite",
          "textTransform": "Großschreibung",
          "letterSpacing": "Zeichenabstand",
          "lineHeight": "Zeilenhöhe",
          "horizontalAlign": "Ausrichtung",
          "activeWordScale": "Größe aktives Wort",
          "opacity": "Deckkraft"
        }
      },
      "Presets": {
        "hypecast": "Hypecast",
        "modern-bold": "Modern Bold",
        "tiktok-style": "Kräftig",
        "box-highlight": "Box Highlight",
        "subtitle-classic": "Klassisch",
        "minimal-clean": "Minimal",
        "neon-glow": "Neon",
        "instagram-reels": "Reels",
        "youtube-shorts": "Shorts",
        "podcast-pro": "Podcast Pro"
      }
    }
  },
  "Breadcrumbs": {
    "podcasts": "Podcasts"
  },
  "Login": {
    "Email confirmation text": "Vielen Dank, dass du deine E-Mail-Adresse bestätigt hast. Bitte melde dich an, um fortzufahren.",
    "Login title": "Anmeldung",
    "Login": "Anmelden",
    "Password": "Passwort",
    "Email": "E-Mail",
    "The email address is required": "Die E-Mail-Adresse ist erforderlich",
    "The email address is not valid": "Die E-Mail-Adresse ist ungültig",
    "The email address or password do not exist": "E-Mail-Adresse oder Passwort sind ungültig",
    "This account has been blocked": "Dieser Account wurde blockiert",
    "An unknown error has occured": "Ein unbekannter Fehler ist aufgetreten",
    "Your organization is currently deactivated": "Deine Organization ist zurzeit deaktiviert",
    "Please confirm your email address": "Bitte bestätige deine E-Mail-Adresse",
    "Your password is required": "Dein Passwort ist erforderlich",
    "Forgot password?": "Passwort vergessen?",
    "Imprint": "Impressum",
    "Data protection": "Datenschutzerklärung",
    "Teaser headline": "HYPECAST<br> Your All-in-One Corporate Podcasting Solution",
    "Teaser subline": "Create and distribute your internal and external corporate podcasts - easy and safe! Manage your audio content, premium content, and subscribers in one tool. Create individual audiences and personalized, curated playlist for your audiences."
  },
  "Password reset": {
    "Reset password": "Passwort zurücksetzen",
    "Change your password": "Ändern Sie Ihr Passwort",
    "The email address is required": "Die E-Mail Adresse ist erforderlich",
    "The email address is invalid": "Die E-Mail Adresse ist ungültig",
    "This email does not exist in our system": "Diese E-Mail existiert nicht in unserem System",
    "The email can have a maximum of 256 characters": "Die E-Mail kann maximal 256 Zeichen lang sein",
    "email send": "Sie erhalten von uns eine E-Mail an die angegebene E-Mail-Adresse.\nIn dieser\nbesagten\nE-Mail erhalten Sie eine Anleitung, wie Sie Ihr Passwort zurücksetzen können.\nIhr Passwort zurücksetzen können.",
    "The password is required": "Das Passwort ist erforderlich",
    "password length": "Das neue Kennwort muss mindestens 8 Zeichen enthalten und eine\nKombination aus Sonderzeichen, Zahlen und Groß- und Kleinbuchstaben darstellen.",
    "password confirm": "Neues Passwort bestätigen",
    "new password confirm": "Sie müssen das neue Passwort bestätigen",
    "passwords not match": "Die Passwörter stimmen nicht überein",
    "new password": "Geben Sie Ihr neues Passwort ein, um Ihr aktuelles Passwort zurückzusetzen",
    "Cancel": "Abbrechen",
    "Login": "Anmelden?",
    "Login Button": "Anmelden",
    "Imprint": "Impressum",
    "Data protection": "Datenschutz"
  },
  "Episode transcript": {
    "Title": "Transcript",
    "Empty": "No transcript yet for this episode.",
    "Trigger": "Generate transcript",
    "Pending": "Transcription queued…",
    "Processing": "Transcribing audio. This may take a few minutes.",
    "Failed": "Transcription failed.",
    "ErrorDetails": "Details",
    "Retry": "Retry transcription",
    "Loading": "Loading transcript…",
    "LoadError": "Could not load transcript.",
    "UnknownSpeaker": "Speaker",
    "AutoScroll": "Auto-scroll",
    "AutoScrollOn": "Auto-scroll is on. Click to stop the transcript from following the audio",
    "AutoScrollOff": "Auto-scroll is off. Click to follow the audio again",
    "Copy": "Copy",
    "CopyTooltip": "Copy the transcript to your clipboard",
    "Copied": "Transcript copied to clipboard",
    "CopyFailed": "Could not copy transcript",
    "Download": "Download",
    "DownloadTooltip": "Download the transcript as a .txt file",
    "SpeakerRename": {
      "Trigger": "Edit speakers",
      "Tooltip": "Rename the speakers in this transcript",
      "Title": "Rename speakers",
      "Hint": "Listen to each speaker's first sentence to identify them, then enter their real names.",
      "PlaySample": "Play sample",
      "StopSample": "Stop sample",
      "NewName": "New name",
      "Cancel": "Cancel",
      "Save": "Save",
      "Saved": "Speaker names updated.",
      "SaveFailed": "Could not save speaker names. Please try again.",
      "NoSpeakers": "No speakers detected in this transcript."
    },
    "Edit": {
      "Trigger": "Correct",
      "Tooltip": "Correct words and speaker names in this transcript",
      "Save": "Save",
      "SaveWithCount": "Save ({{count}})",
      "Cancel": "Cancel",
      "Saved": "Transcript corrections saved.",
      "SaveFailed": "Could not save the corrections. Your changes are still here. Please try again.",
      "SaveIgnored": "The server did not apply the corrections. The API may be outdated. Please contact support.",
      "DiscardTitle": "Discard corrections?",
      "DiscardMessage": "You have unsaved corrections. Leaving edit mode discards them.",
      "PassageLabel": "Text of this passage",
      "SpeakerHint": "Edit each passage like normal text: fix words, remove fillers, rewrite a sentence. Words you do not touch keep their exact timing. Esc restores a passage. Renaming a speaker applies to all their passages."
    }
  },
  "Podcast form": {
    "Notifications": {
      "Heading": "Benachrichtigung bei neuen Folgen",
      "Description": "Wenn eine neue Folge dieses Podcasts veröffentlicht wird, werden berechtigte Hörer benachrichtigt. Einzelne Folgen können diese Einstellung überschreiben.",
      "Toggle label": "Hörer über neue Folgen benachrichtigen"
    }
  },
  "Podcast sample": {
    "Badge": "Beispiel",
    "Tooltip": "Beispielinhalt zum Ausprobieren. Du kannst ihn jederzeit löschen.",
    "Notice": "Das ist ein Beispiel-Podcast. Lösche ihn, wenn du ihn nicht mehr brauchst.",
    "Delete": "Podcast löschen"
  },
  "Episode form": {
    "Notifications": {
      "Heading": "Benachrichtigung (Ausnahme)",
      "Description": "Standard dieses Podcasts: {{podcastDefault}}. Hier nur überschreiben, wenn nötig.",
      "Inherit": "Podcast-Standard verwenden ({{podcastDefault}})",
      "Force on": "Benachrichtigen, auch wenn Podcast-Standard aus ist",
      "Force off": "Nicht benachrichtigen, auch wenn Podcast-Standard an ist",
      "Yes": "benachrichtigen",
      "No": "nicht benachrichtigen"
    },
    "Type": {
      "Description": "Bitte wähle den Typ dieser Episode: Full, Trailer oder Bonus. Der Typ kann nach dem Anlegen nicht mehr geändert werden.",
      "Full": "Full",
      "Trailer": "Trailer",
      "Bonus": "Bonus",
      "Info": {
        "Full": "Eine Full-Episode ist eine eigenständige Folge dieses Podcasts.",
        "Trailer": "Ein Trailer ist ein Teaser für diesen Podcast. Er erscheint mit Play-Button im Podcast-Header statt in der Episodenliste.",
        "Bonus": "Ein Bonus ist Zusatzmaterial, z. B. ein Interview oder Behind-the-Scenes. Er erscheint in der Episodenliste mit Bonus-Badge."
      },
      "Trailer exists warning": "Dieser Podcast hat bereits einen veröffentlichten Trailer. Du kannst einen weiteren anlegen, die Apps spielen aber immer den zuletzt veröffentlichten Trailer."
    }
  },
  "TenantLifecycle": {
    "Trial": "Du nutzt Hypecast in der Testphase.",
    "TrialDaysLeft": "Testphase: noch {{days}} Tage",
    "TrialOneDayLeft": "Testphase: noch 1 Tag",
    "TrialEndsToday": "Testphase: endet heute",
    "ReadOnly": "Deine Testphase ist beendet. Dein Workspace ist schreibgeschützt; deine Hörerinnen und Hörer können noch bis {{date}} zuhören. Wir berechnen dir nichts.",
    "ReadOnlyNoDate": "Deine Testphase ist beendet. Dein Workspace ist schreibgeschützt. Wir berechnen dir nichts.",
    "Offline": "Deine Podcasts sind offline. Am {{date}} wird der Workspace gelöscht.",
    "OfflineNoDate": "Deine Podcasts sind offline.",
    "Activate": "Plan aktivieren",
    "Dismiss": "Hinweis ausblenden",
    "Contact": "Termin vereinbaren",
    "ActivationUnavailable": "Die Aktivierung ist gerade nicht erreichbar. Bitte versuche es später erneut oder schreib an support@hypecast.one.",
    "ActivationForbidden": "Nur Company Admins deines Workspace können den Plan aktivieren.",
    "Checkout": {
      "Title": "Plan aktivieren",
      "Loading": "Einen Moment, wir laden deine Optionen.",
      "Processing": "Wir schließen die Aktivierung ab …",
      "StepPlan": "Schritt 1 von 2: Plan",
      "StepPayment": "Schritt 2 von 2: Zahlung",
      "PlanLegend": "Plan",
      "IntervalLegend": "Abrechnung",
      "Monthly": "Monatlich",
      "Yearly": "Jährlich",
      "PerMonth": "{{price}} / Monat",
      "PerYear": "{{price}} / Jahr",
      "NotAvailable": "Nicht verfügbar",
      "Rss": "Privater RSS-Feed (Spotify/Apple)",
      "PlanOnly": "{{plan}}",
      "PlanWithRss": "{{plan}}, mit privatem RSS-Feed",
      "Continue": "Weiter",
      "Back": "Zurück",
      "Cancel": "Abbrechen",
      "Close": "Schließen",
      "Done": "Fertig",
      "SavedCard": "{{card}}, gültig bis {{expiry}}",
      "SavedCardNoExpiry": "{{card}}",
      "SavedSepa": "SEPA-Lastschrift {{account}}",
      "SavedBankAccount": "Bankkonto {{account}}",
      "UseOtherMethod": "Andere Zahlungsmethode",
      "UseSavedMethod": "Gespeicherte Zahlungsmethode verwenden",
      "ChangePlan": "Plan ändern",
      "PaymentLoading": "Zahlungsformular wird geladen …",
      "Submitting": "Wird aktiviert …",
      "ChargeTrial": "Deine Testphase läuft bis {{date}}. Am {{date}} buchen wir {{price}} ab, vorher nichts.",
      "ChargeToday": "Wir buchen heute {{price}} ab.",
      "BilledFrom": "Abgerechnet wird ab dem {{date}}",
      "BilledFromTrialEnd": "Abgerechnet wird ab dem Ende deiner Testphase",
      "BilledFromToday": "Abgerechnet wird ab heute",
      "Scheduled": "Plan gespeichert. Deine Testphase läuft weiter bis {{date}}, danach startet {{plan}} automatisch.",
      "ScheduledNoDate": "Plan gespeichert. Nach deiner Testphase startet {{plan}} automatisch.",
      "Activated": "Plan aktiviert. Dein Workspace ist wieder vollständig freigeschaltet.",
      "PaymentFailed": "Die Zahlung hat nicht geklappt.",
      "PaymentFailedHint": "Du kannst die offene Rechnung direkt bezahlen oder eine andere Zahlungsmethode verwenden.",
      "OpenInvoice": "Rechnung öffnen",
      "HandoffContact": "Für deinen Workspace stimmen wir den Plan gemeinsam ab. Vereinbare dafür einen Termin mit uns.",
      "HandoffLink": "Die Aktivierung geht auf einer eigenen Seite weiter.",
      "Errors": {
        "WorkspaceGone": "Dieser Workspace wird gelöscht und lässt sich nicht mehr aktivieren. Schreib uns an support@hypecast.one.",
        "SubscriptionEnded": "Dein Plan ist bereits beendet und lässt sich hier nicht mehr aktivieren. Schreib uns an support@hypecast.one, wir helfen dir weiter.",
        "SetupIncomplete": "Die Karte ist noch nicht bestätigt. Bitte gib sie noch einmal ein.",
        "PriceUnavailable": "Diese Kombination ist gerade nicht buchbar. Bitte wähle eine andere.",
        "StripeUnavailable": "Das Zahlungsformular konnte nicht geladen werden. Bitte prüfe deine Verbindung oder erlaube stripe.com in deinem Blocker und versuche es erneut.",
        "RedirectFailed": "Die Zahlungsart wurde nicht bestätigt. Bitte versuche es noch einmal oder verwende eine andere Karte.",
        "CardRejected": "Die Karte wurde nicht akzeptiert. Bitte prüfe die Angaben oder verwende eine andere Karte.",
        "PaymentMethodUnavailable": "Die gespeicherte Zahlungsmethode lässt sich nicht verwenden. Bitte gib eine andere ein."
      }
    }
  },
  "AuthAccessDenied": {
    "Title": "Kein Zugriff auf diesen Workspace",
    "Text": "Dein Konto gehört nicht zu diesem Workspace. Melde dich mit einem anderen Konto an oder bitte einen Company Admin des Workspace, dich einzuladen.",
    "Details": "Details: {{description}}",
    "SwitchAccount": "Mit anderem Konto anmelden"
  },
  "PlanLimit": {
    "Podcasts": "Dein Plan enthält {{limit}} Podcasts. Wenn du weitere anlegen möchtest, wechsle zu einem größeren Plan.",
    "PodcastsOne": "Dein Plan enthält 1 Podcast. Wenn du weitere anlegen möchtest, wechsle zu einem größeren Plan.",
    "PodcastsNoLimit": "Dein Plan enthält keine weiteren Podcasts. Wenn du weitere anlegen möchtest, wechsle zu einem größeren Plan.",
    "Seats": "Dein Plan enthält {{limit}} Creator-Plätze. Wenn du weitere brauchst, wechsle zu einem größeren Plan.",
    "SeatsOne": "Dein Plan enthält 1 Creator-Platz. Wenn du weitere brauchst, wechsle zu einem größeren Plan.",
    "SeatsNoLimit": "Dein Plan enthält keine weiteren Creator-Plätze. Wenn du weitere brauchst, wechsle zu einem größeren Plan."
  }
}
